// src/store/store.ts
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import countryReducer from '../features/country/countrySlice'; 
import adsReducer from "../features/ads/adsSlice";
import adDetailsReducer from "../features/adDetails/adDetailsSlice";
import bookingReducer from "../features/booking/bookingSlice";
import addressMemoryReducer from "../features/addressMemory/addressMemorySlice";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        country: countryReducer, 
        ads: adsReducer,
        adDetails: adDetailsReducer,
        booking: bookingReducer,
        addressMemory: addressMemoryReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
